var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSustainabilityPageShape3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 347.22,
    height: 347.22
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SustainabilityPageShape3_svg__SustainabilityPageShape3Mask",
    clipPathUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 .5a.5.5 0 11-1 0 .5.5 0 011 0"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNDcuMjIiIGhlaWdodD0iMzQ3LjIyIiB2aWV3Qm94PSIwIDAgMzQ3LjIyIDM0Ny4yMiI+CiAgPGRlZnM+CgkJPGNsaXBQYXRoCgkJCWlkPSJTdXN0YWluYWJpbGl0eVBhZ2VTaGFwZTNNYXNrIgoJCQljbGlwUGF0aFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIKCQk+CiAgICAgIDxwYXRoIGQ9Ik0xLDAuNSBjMCwwLjI3NiwtMC4yMjQsMC41LC0wLjUsMC41IFMwLDAuNzc2LDAsMC41IFMwLjIyNCwwLDAuNSwwIFMxLDAuMjI0LDEsMC41Ii8+CiAgICA8L2NsaXBQYXRoPgogIDwvZGVmcz4KPC9zdmc+Cg==";
export { SvgSustainabilityPageShape3 as ReactComponent };